import React, { FC } from 'react';
import type { QuestionnaireQuestion } from '../types/questionnaire';
import {
  DualPeriodQuestion, ImpairmentQuestion, FrequencyQuestion, SelfReportQuestion,
} from './question-types';

export interface QuestionRendererProps {
  question: QuestionnaireQuestion;
  answers: Record<string, any>;
  setAnswers: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  onComplete: () => void;
}

const QuestionRenderer: FC<QuestionRendererProps> = ({
  question,
  answers,
  setAnswers,
  onComplete,
}) => {
  switch (question.type) {
    case 'dual-period':
      return <DualPeriodQuestion question={question} answers={answers} setAnswers={setAnswers} onComplete={onComplete} />;

    case 'radio':
    case 'checkbox':
    case 'text':
      return <ImpairmentQuestion question={question} answers={answers} setAnswers={setAnswers} onComplete={onComplete} />;

    case 'frequency':
      return <FrequencyQuestion question={question} answers={answers} setAnswers={setAnswers} onComplete={onComplete} />;

    case 'frequency-with-followup':
      return <SelfReportQuestion question={question} answers={answers} setAnswers={setAnswers} onComplete={onComplete} />;

    default:
      return null;
  }
};

export default QuestionRenderer;
